export const YoutubeThumbUrl = 'https://i.ytimg.com/vi/RnksIraDzWk/mqdefault.jpg'
export const YoutubeUrl = 'https://www.youtube.com/embed/RnksIraDzWk'



// WEBPACK FOOTER //
// ./src/estimate_list/utils/constants.js